import Main from "src/layouts/Main";
import React from "react";
import { NextSeo } from "next-seo";
import { Heading } from "@chakra-ui/react";

export default function betingelser({}) {
  const prices =
    process.env.NEXT_PUBLIC_COMPANY_NAME === "legalis"
      ? [
          `kr. 1050 per 30 min (inkludert mva.) og kr. 2300 per time (inkludert
          mva.).`,
          "Timepris for forarbeid er kr. 2300 (inkludert mva.) per time.",
        ]
      : [
          "kr. 1.150 eks. mva. pr. 30 min (1.437 inkl. mva.) og kr. 2.300 eks. mva. pr. time (2.875 inkl. mva.)",
          "Timepris for forarbeid er kr. 2.100 eks. mva. (2.625 inkl. mva.) for fullmektig, kr. 2.300 eks. mva. pr. time (2.875 inkl. mva.) for advokat, og kr. 2.450 eks. mva. (3.062 inkl. mva.) for partner.",
        ];
  return (
    <Main>
      <div className="root">
        <NextSeo
          title={`Vilkår for bruk - ${process.env.NEXT_PUBLIC_COMPANY_NAME} timebestilling`}
          description="Les mer om vilkår for bruk av vår løsning for digital saksbehandling."
        ></NextSeo>
        <Heading size={"lg"}>
          Vilkår for bruk av {process.env.NEXT_PUBLIC_FRONTEND_URL}
        </Heading>

        <p>1. Om tjenesten og partene</p>
        <p>
          Denne avtalen er en avtale om digitalt møte med din valgte advokat hos
          {process.env.NEXT_PUBLIC_COMPANY_NAME}.
        </p>
        <p>
          Tjenesten tilbys av{" "}
          <strong>{process.env.NEXT_PUBLIC_FULL_COMPANY_NAME} AS</strong>,
          Org.nr. 974675366, Universitetsgata 8, 0164 Oslo. Tlf. 22402300,
          e-post{" "}
          <a href={`mailto:${process.env.NEXT_PUBLIC_COMPANY_EMAIL}`}>
            {process.env.NEXT_PUBLIC_COMPANY_EMAIL}
          </a>{" "}
          ("
          {process.env.NEXT_PUBLIC_COMPANY_NAME}").
        </p>
        <p>
          Avtalen består av disse vilkårene og eventuelt særskilt avtalte
          vilkår. Ved eventuell motstrid mellom vilkår, går det som er særskilt
          avtalt mellom partene foran. Lovgivning som regulerer kjøp av
          tjenester mellom næringsdrivende og forbrukere vil supplere denne
          avtalen.
        </p>
        <p>
          Avtalen inneholder informasjon om partenes rettigheter og plikter,
          samt behandling av personopplysninger, ansvarsbegrensninger og
          tvisteløsning.
        </p>
        <p>2. Vilkår for å bruke tjenesten</p>
        <p>
          For å kunne bruke eller få tilgang til tjenesten må du godta vilkårene
          i denne avtalen og logge inn på {process.env.NEXT_PUBLIC_FRONTEND_URL}{" "}
          hvor tjenesten vil bli gjort tilgjengelig. Du godtar også at{" "}
          {process.env.NEXT_PUBLIC_COMPANY_NAME}, for å kunne oppfylle avtalen
          mellom partene, behandler dine personopplysninger slik dette er
          beskrevet i {process.env.NEXT_PUBLIC_COMPANY_NAME} sin
          personvernerklæring.
        </p>
        <p>
          Tjenesten er personlig og kan ikke overføres til eller benyttes av
          andre enn deg selv uten vårt samtykke.
        </p>
        <p>3. Avtaleinngåelse og levering</p>
        <p>
          Avtalen er bindende for begge parter når du har sendt din bestilling
          til {process.env.NEXT_PUBLIC_COMPANY_NAME}. Første møte med advokaten
          betales på forhånd. Eventuelt arbeid før første møte og betaling for
          dette, f.eks. gjennomgang av dokumenter, avtales med advokaten og
          betales på forhånd. Videre bistand fra advokaten avtales direkte med
          advokaten i{process.env.NEXT_PUBLIC_FRONTEND_URL}.
        </p>
        <p>
          Avtalen er ikke bindende hvis det har forekommet skrive- eller
          tastefeil i tilbudet fra {process.env.NEXT_PUBLIC_COMPANY_NAME} eller
          i din bestilling, og den annen part innså eller burde ha innsett at
          det forelå en slik feil.
        </p>
        <p>
          Tjenesten er levert når den er gjort tilgjengelig for deg på det
          avtalte leveringstidspunktet.
        </p>
        <p>4. Kommunikasjon</p>
        <p>
          Kommunikasjon med advokaten skjer kun elektronisk i{" "}
          <a href={process.env.NEXT_PUBLIC_FRONTEND_URL}>
            {process.env.NEXT_PUBLIC_FRONTEND_URL}
          </a>
          . Du blir varslet om booket møte i e-posten du oppgir.
        </p>
        <p>
          Du får varsel om gjennomførte betalinger og kvitteringer, nye
          meldinger, nye filer lastet opp, nye saker opprettet av advokat, nye
          møter opprettet av advokat, endring av møter, avbestilling og
          påminnere om møter som nærmer seg.
        </p>
        <p>
          Selve møtet kan skje via telefon dersom du har avtalt dette med
          advokaten.
        </p>
        <p>5. Pris og betaling</p>
        <p>
          Prisen for tjenesten følger av den til enhver tid gjeldende prisliste
          for levering av {process.env.NEXT_PUBLIC_COMPANY_NAME} sine tjenester.
        </p>
        <p>
          Pris for møte med advokat i {process.env.NEXT_PUBLIC_FRONTEND_URL} er
          {prices[0]}
        </p>
        <p>
          Eventuelt forarbeid betales i tillegg til møtet, etter nærmere avtale
          med advokat.
        </p>
        <p>
          {prices[1]} Det beregnes minst en fjerdedels time (ett kvarter) for
          hver arbeidsøkt som utføres. Det gjøres i den forbindelse oppmerksom
          på at alt tidsforbruk i anledning saken, herunder inngående og
          utgående korrespondanse (også elektronisk) og telefonsamtaler danner
          grunnlag for salæret.
        </p>
        <p>
          Videre beregning av tid og betaling for dette etter møtet blir avtalt
          med din advokat. Det gis et pristilbud i{" "}
          {process.env.NEXT_PUBLIC_FRONTEND_URL} for oppdraget eller deler av
          oppdraget. Pristilbudet kan aksepteres eller forkastes av deg, og
          forhåndsbetales ved aksept av tilbudet.
        </p>
        <p>
          Betaling skjer på det tidspunkt som partene har avtalt, ved hjelp av
          den eller de betalingsløsninger som{" "}
          {process.env.NEXT_PUBLIC_COMPANY_NAME} har tilgjengelig til enhver
          tid.
        </p>
        <p>6. Avbestilling og angrerett</p>
        <p>Du kan avbestille tjenesten før den blir levert.</p>
        <p>
          Avbestilling mot refusjon av det innbetalte beløpet for møtet kan skje
          frem til 24 timer før møtet. Avbestilles møtet senere enn 24 timer før
          oppsatt møtetid, tas det betalt kr. 250,- (inkl. mva.) i standard
          avbestillingsgebyr.
        </p>
        <p>
          Dersom det er gitt samtykke til førtidig oppstart av levering før
          angrefrist har løpt ut, og advokat har utført arbeid før møtet, f.eks.
          gjennomgang av skriftlig materiale, blir dette fakturert iht. avtale
          med advokat.
        </p>
        <p>
          Du får varsel om møtet ditt før siste mulighet til kostnadsfri
          avbestilling.
        </p>
        <p>
          Du kan enkelt avbestille møte i {process.env.NEXT_PUBLIC_FRONTEND_URL}
          . For å avbestille logger du deg inn på «min-side», finner møtet i
          listen og klikker «Avbestill / refunder». Du vil motta en
          avbestillingsbekreftelse på e-post og få pengene tilbake på din konto
          innen 5-10 dager.
        </p>
        <p>
          Du har i tillegg 14 dagers angrerett fra den dagen avtalen inngås, så
          sant avtaleinngåelsen har skjedd utelukkende ved hjelp av
          fjernkommunikasjon eller utenfor vårt faste utsalgssted.
        </p>
        <p>
          Du kan bruke angreretten ved å gi beskjed til{" "}
          {process.env.NEXT_PUBLIC_COMPANY_NAME} innen 14 dager fra dagen etter
          avtalen ble inngått. Dersom fristen ender på en lørdag, helligdag
          eller høytidsdag forlenges fristen til nærmeste virkedag.
        </p>
        <p>
          Angrefristen anses overholdt dersom melding er sendt før utløpet av
          fristen. Du har bevisbyrden for at angreretten har blitt gjort
          gjeldende, og meldingen bør derfor skje skriftlig (angrerettskjema,
          e-post eller brev).
        </p>
        <p>
          Angrerett gjelder ikke etter at tjenesten er fullført, forutsatt at du
          uttrykkelig har samtykket til at levering starter før utløpet av
          angrefristen på 14 dager, og har erkjent at det ikke er angrerett
          etter at tjenesten er fullført.
        </p>
        <p>
          Dersom du benytter deg av angreretten etter uttrykkelig å ha anmodet
          advokaten om å starte oppdraget før angrefristen er gått ut og før
          oppdraget er fullført, må du betale et rimelig vederlag for den delen
          av oppdraget som er levert frem til tidspunkt for bruk av angreretten.
          I praksis betyr dette betaling for medgått tid.
        </p>
        <p>7. Forsinket levering</p>
        <p>
          Dersom {process.env.NEXT_PUBLIC_COMPANY_NAME} ikke leverer tjenesten
          eller leverer den for sent i henhold til avtalen mellom partene, og
          dette ikke skyldes deg eller forhold på din side, kan du
          enten&nbsp;holde vederlag tilbake,
          kreve&nbsp;oppfyllelse,&nbsp;heve&nbsp;avtalen og/eller
          kreve&nbsp;erstatning&nbsp;fra {process.env.NEXT_PUBLIC_COMPANY_NAME}.
        </p>
        <p>
          Du må gi {process.env.NEXT_PUBLIC_COMPANY_NAME} melding om krav som
          fremsettes som følge av forsinkelse. Dine krav kan tapes etter
          alminnelige regler om passivitet hvis du venter så lenge med å gi
          melding at det ville virke illojalt overfor{" "}
          {process.env.NEXT_PUBLIC_COMPANY_NAME} å gjøre gjeldende krav. Retten
          til å gjøre gjeldende krav kan tapes også etter foreldelseslovens
          regler om foreldelse.
        </p>
        <p>
          Duhar bevisbyrden for at krav er blitt gjort gjeldende, og melding om
          dette bør derfor skje skriftlig (e-post eller brev).
        </p>
        <p>7.1 Tilbakeholdsrett</p>
        <p>
          Du kan holde tilbake vederlag for å dekke krav som følge av forsinket
          levering fra {process.env.NEXT_PUBLIC_COMPANY_NAME} side, men ikke
          åpenbart mer enn det som vil gi betryggende sikkerhet for kravet.
        </p>
        <p>7.2 Oppfyllelse</p>
        <p>
          Du kan fastholde kjøpet og kreve oppfyllelse fra{" "}
          {process.env.NEXT_PUBLIC_COMPANY_NAME}. Du kan imidlertid ikke kreve
          oppfyllelse dersom det foreligger en hindring som{" "}
          {process.env.NEXT_PUBLIC_COMPANY_NAME} ikke kan overvinne, eller
          dersom oppfyllelse vil medføre en så stor ulempe eller kostnad for
          {process.env.NEXT_PUBLIC_COMPANY_NAME} at det står i vesentlig
          misforhold til din interesse i at{" "}
          {process.env.NEXT_PUBLIC_COMPANY_NAME} oppfyller. Skulle vanskene
          falle bort innen rimelig tid, kan du likevel kreve oppfyllelse.
        </p>
        <p>7.3 Heving</p>
        <p>
          Dersom {process.env.NEXT_PUBLIC_COMPANY_NAME} ikke leverer på
          tidspunktet som er avtalt mellom partene, kan du heve kjøpet dersom
          tjenesten heller ikke blir levert uten unødig opphold eller innen en
          tilleggsfrist som partene uttrykkelig har blitt enige om
        </p>
        <p>
          Du kan heve kjøpet umiddelbart hvis{" "}
          {process.env.NEXT_PUBLIC_COMPANY_NAME} nekter å levere tjenesten eller
          det er klart at {process.env.NEXT_PUBLIC_COMPANY_NAME} ikke kommer til
          å levere. Tilsvarende gjelder hvis det er avtalt eller fremgår klart
          av omstendighetene at levering innen eller på et bestemt tidspunkt er
          avgjørende for deg, og {process.env.NEXT_PUBLIC_COMPANY_NAME} ikke har
          levert til riktig tid.
        </p>
        <p>7.4 Erstatning</p>
        <p>
          Du kan kreve erstatning for lidt tap som følge av forsinkelsen. Dette
          gjelder imidlertid ikke dersom {process.env.NEXT_PUBLIC_COMPANY_NAME}{" "}
          godtgjør at forsinkelsen skyldes hindring utenfor{" "}
          {process.env.NEXT_PUBLIC_COMPANY_NAME} kontroll som man ikke med
          rimelighet kunne blitt tatt i betraktning på avtaletiden, unngått,
          eller overvunnet følgene av.
        </p>
        <p>
          Erstatningen skal svare til tapet, herunder utlegg, prisforskjell og
          tapt fortjeneste, som du er påført ved kontraktsbruddet. Dette gjelder
          likevel bare tap som en med rimelighet kunne ha forutsett som en mulig
          følge av kontraktsbruddet. Som tap regnes også at du påføres en
          konkret og ikke ubetydelig ulempe ved kontraktsbruddet.
        </p>
        <p>
          Det kan ikke kreves erstatning for tap som følge av personskade eller
          for tap i næringsvirksomhet.
        </p>
        <p>8. Mangel ved tjenesten</p>
        <p>
          Tjenesten vil kunne ha en mangel dersom den ikke er i samsvar med det
          som er avtalt om blant annet art, mengde, kvalitet, veiledning og
          kundeservice.
        </p>
        <p>
          Hvis det foreligger en mangel ved tjenesten og dette ikke skyldes deg
          eller forhold på din side, kan du enten&nbsp;holde vederlag tilbake,
          kreve&nbsp;retting eller omlevering, kreve
          prisavslag,&nbsp;heve&nbsp;avtalen og/eller
          kreve&nbsp;erstatning&nbsp;fra {process.env.NEXT_PUBLIC_COMPANY_NAME}.
        </p>
        <p>
          Du må gi {process.env.NEXT_PUBLIC_COMPANY_NAME} melding om krav som
          fremsettes som følge av mangelen. Dine krav kan tapes etter
          alminnelige regler om passivitet hvis du venter så lenge med å gi
          melding at det ville virke illojalt overfor{" "}
          {process.env.NEXT_PUBLIC_COMPANY_NAME} å gjøre gjeldende krav. Retten
          til å gjøre gjeldende krav kan tapes også etter foreldelseslovens
          regler om foreldelse.
        </p>
        <p>
          Du har bevisbyrden for at krav er blitt gjort gjeldende, og melding om
          dette bør derfor skje skriftlig (e-post eller brev).
        </p>
        <p>8.1 Tilbakeholdsrett</p>
        <p>
          Du kan holde tilbake vederlag for å dekke krav som følge av mangelen,
          men ikke åpenbart mer enn det som vil gi betryggende sikkerhet for
          kravet.
        </p>
        <p>8.2 Retting eller omlevering (avhjelp)</p>
        <p>
          Du kan kreve at en mangel rettes eller at en tilsvarende ytelse uten
          mangel blir levert. {process.env.NEXT_PUBLIC_COMPANY_NAME} kan
          motsette seg dine krav dersom gjennomføringen av kravet er umulig
          eller påfører {process.env.NEXT_PUBLIC_COMPANY_NAME} urimelige
          kostnader.
        </p>
        <p>
          Uavhengig av hva du ønsker, står{" "}
          {process.env.NEXT_PUBLIC_COMPANY_NAME} fritt til å velge om avhjelp
          skal skje gjennom at en mangel rettes eller ved at det leveres en
          tilsvarende ytelse uten mangel (omlevering), så sant dette skjer innen
          rimelig tid og ikke medfører en kostnad eller vesentlig ulempe for
          deg.
        </p>
        <p>
          Dersom retting eller omlevering ikke skjer innen rimelig tid, eller
          medfører en kostnad eller vesentlig ulempe for deg, kan du avvise
          dette.
        </p>
        <p>
          Selv om du verken krever retting eller omlevering, kan{" "}
          {process.env.NEXT_PUBLIC_COMPANY_NAME} tilby retting eller omlevering
          hvis tilbud om dette fremsettes uten opphold.
        </p>
        <p>
          Du kan likevel kreve prisavslag eller heving umiddelbart hvis mangelen
          etter sin art er så alvorlig at det ikke er rimelig å forvente at du
          skal godta et avhjelpstilbud.
        </p>
        <p>8.3 Prisavslag</p>
        <p>
          Hvis mangelen ikke rettes eller ytelsen ikke omleveres, kan du kreve
          et prisavslag slik at forholdet mellom nedsatt og avtalt pris svarer
          til forholdet mellom ytelsens verdi i mangelfull og kontraktsmessig
          stand på leveringstiden.
        </p>
        <p>8.4 Heving</p>
        <p>
          I stedet for å kreve prisavslag kan du heve avtalen, med mindre
          {process.env.NEXT_PUBLIC_COMPANY_NAME} beviser at mangelen er
          uvesentlig.
        </p>
        <p>8.5 Erstatning</p>
        <p>Du kan kreve erstatning for lidt tap som følge av mangelen.</p>
        <p>
          Erstatningen skal svare til tapet, herunder utlegg, prisforskjell og
          tapt fortjeneste, som du er påført ved kontraktsbruddet. Dette gjelder
          likevel bare tap som en med rimelighet kunne ha forutsett som en mulig
          følge av kontraktsbruddet. Som tap regnes også at du påføres en
          konkret og ikke ubetydelig ulempe ved kontraktsbruddet.
        </p>
        <p>
          Det kan ikke kreves erstatning for tap som følge av personskade eller
          for tap i næringsvirksomhet.
        </p>
        <p>9. Kontraktsbrudd fra kjøper</p>
        <p>
          Dersom du ikke betaler eller oppfyller de øvrige pliktene etter
          avtalen eller gjeldende lovgivning, og dette ikke skyldes{" "}
          {process.env.NEXT_PUBLIC_COMPANY_NAME}
          eller forhold på {process.env.NEXT_PUBLIC_COMPANY_NAME} side, kan
          {process.env.NEXT_PUBLIC_COMPANY_NAME} holde&nbsp;ytelsen tilbake,
          kreve&nbsp;oppfyllelse&nbsp;av avtalen, kreve
          avtalen&nbsp;hevet&nbsp;samt kreve&nbsp;erstatning og rente&nbsp;fra
          kjøperen.
        </p>
        <p>9.1 Tilbakeholdsrett</p>
        <p>
          Dersom du ikke betaler på avtalt tidspunkt, kan{" "}
          {process.env.NEXT_PUBLIC_COMPANY_NAME} holde ytelsen tilbake eller
          stanse videre levering inntil du betaler eller stiller betryggende
          sikkerhet for kravet.
        </p>
        <p>9.2 Oppfyllelse</p>
        <p>
          {process.env.NEXT_PUBLIC_COMPANY_NAME} kan fastholde avtalen og kreve
          at du betaler kjøpesummen. Dette gjelder likevel ikke så lenge
          betalingen hindres av stans i betalingsformidlingen eller andre
          forhold utenfor din kontroll som du ikke kan overvinne.
        </p>
        <p>
          Er tjenesten ennå ikke levert, tapes retten til å kreve oppfyllelse
          hvis {process.env.NEXT_PUBLIC_COMPANY_NAME} venter urimelig lenge med
          å fremme kravet.
        </p>
        <p>9.3 Heving</p>
        <p>
          {process.env.NEXT_PUBLIC_COMPANY_NAME} kan heve avtalen på grunn av
          forsinket betaling eller annet vesentlig kontraktsbrudd fra din side.
          Fastsetter {process.env.NEXT_PUBLIC_COMPANY_NAME} en rimelig
          tilleggsfrist for betaling og du ikke betaler innen denne fristen, kan
          {process.env.NEXT_PUBLIC_COMPANY_NAME} heve kjøpet.
        </p>
        <p>
          {process.env.NEXT_PUBLIC_COMPANY_NAME} forbeholder seg retten til å
          heve avtalen også i tilfeller hvor du har fått levert tjenesten.
        </p>
        <p>9.4 Renter ved forsinket betaling/inkassogebyr</p>
        <p>
          Dersom du ikke betaler kjøpesummen i henhold til avtalen, kan{" "}
          {process.env.NEXT_PUBLIC_COMPANY_NAME}
          kreve renter av kjøpesummen etter forsinkelsesrenteloven. Ved
          manglende betaling kan kravet, etter forutgående varsel, bli sendt til
          inkasso. Du kan da bli holdt ansvarlig for gebyr etter inkassoloven.
        </p>
        <p>9.5 Erstatning</p>
        <p>
          {process.env.NEXT_PUBLIC_COMPANY_NAME} kan kreve erstatning for det
          tapet {process.env.NEXT_PUBLIC_COMPANY_NAME} lider som følge av
          kontraktsbrudd fra din side. Dette gjelder likevel ikke så langt du
          godtgjør at kontraktsbruddet skyldes stans i betalingsformidlingen
          eller en annen hindring utenfor din kontroll som du ikke med
          rimelighet kunne ventes å ha tatt i betraktning på avtaletiden eller å
          unngå eller overvinne følgene av.
        </p>
        <p>
          Erstatningen skal svare til tapet, herunder utlegg, prisforskjell og
          tapt fortjeneste, som {process.env.NEXT_PUBLIC_COMPANY_NAME} er påført
          ved kontraktsbruddet. Dette gjelder likevel bare tap som en med
          rimelighet kunne ha forutsett som en mulig følge av kontraktsbruddet.
        </p>
        <p>
          Hindres du i å oppfylle avtalen til rett tid, skal du melde fra til
          {process.env.NEXT_PUBLIC_COMPANY_NAME} om dette. Får{" "}
          {process.env.NEXT_PUBLIC_COMPANY_NAME} ikke en slik melding innen
          rimelig tid etter at du fikk eller burde ha fått kjennskap til
          hindringen, kan {process.env.NEXT_PUBLIC_COMPANY_NAME} kreve erstattet
          tap som kunne ha vært unngått om meldingen hadde blitt gitt i tide.
        </p>
        <p>9.6 Manglende spesifikasjon</p>
        <p>
          Skal tjenesten utvikles etter dine spesifikasjoner og du ikke bidrar
          med slike spesifikasjoner til avtalt tid eller innen rimelig tid etter
          at {process.env.NEXT_PUBLIC_COMPANY_NAME} har oppfordret til det, kan
          {process.env.NEXT_PUBLIC_COMPANY_NAME} selv bestemme spesifikasjonene
          i samsvar med hva som må antas at er i din interesse. Dette hindrer
          ikke {process.env.NEXT_PUBLIC_COMPANY_NAME} i å gjøre gjeldende andre
          krav.
        </p>
        <p>
          Du vil bli opplyst om de spesifikasjonene som vil bli brukt, og få en
          rimelig frist til å endre spesifikasjonene. Endrer du ikke
          spesifikasjonene i tide etter å ha fått{" "}
          {process.env.NEXT_PUBLIC_COMPANY_NAME} melding, blir{" "}
          {process.env.NEXT_PUBLIC_COMPANY_NAME} sine spesifikasjoner bindende.
        </p>
        <p>10. Personopplysninger</p>
        <p>
          Behandlingsansvarlig for innsamlede personopplysninger er{" "}
          {process.env.NEXT_PUBLIC_COMPANY_NAME}. Med mindre du samtykker til
          noe annet, kan {process.env.NEXT_PUBLIC_COMPANY_NAME}, i tråd med
          personopplysningsloven, kun innhente og lagre de personopplysninger
          som er nødvendig for at {process.env.NEXT_PUBLIC_COMPANY_NAME} skal
          kunne gjennomføre forpliktelsene etter avtalen. Dine
          personopplysninger vil kun bli utlevert til andre hvis det er
          nødvendig for at {process.env.NEXT_PUBLIC_COMPANY_NAME} skal få
          gjennomført avtalen med deg, eller i lovbestemte tilfelle. Mer
          informasjon om behandlingen av kjøpers personopplysninger fremgår av
          {process.env.NEXT_PUBLIC_COMPANY_NAME} personvernerklæring:{" "}
          <a href={`${process.env.NEXT_PUBLIC_MAIN_URL}/personvern`}>
            {process.env.NEXT_PUBLIC_MAIN_URL}/personvern
          </a>
        </p>
        <p>11. Klageadgang og konfliktløsning</p>
        <p>
          Klager rettes til {process.env.NEXT_PUBLIC_COMPANY_NAME} innen rimelig
          tid. Partene skal forsøke å løse eventuelle tvister i minnelighet.
          Dersom dette ikke lykkes, kan kjøperen ta kontakt med
          Forbrukertilsynet for mekling: Se{" "}
          <a href="https://www.forbrukertilsynet.no/har-du-en-klage">
            https://www.forbrukertilsynet.no/har-du-en-klage
          </a>
        </p>
        <p>
          Europa-Kommisjonens klageportal kan også benyttes for å inngi en
          klage. Dette er særlig relevant dersom du er bosatt i et annet
          EU-land. Klagen inngis her:&nbsp;
          <a href="https://ec.europa.eu/consumers/odr">
            https://ec.europa.eu/consumers/odr
          </a>
        </p>
        <p>
          Det opplyses at {process.env.NEXT_PUBLIC_COMPANY_NAME} i henhold til
          regler for advokater har ansvarsforsikring til dekning av eventuelt
          erstatningsansvar som pådras under utøvelse av advokatvirksomhet.
        </p>
        <p>&nbsp;</p>

        <style jsx>{`
          .root {
          }
          @media only screen and (max-width: 1200px) {
            .root {
              padding: 0 20px 0 20px;
            }
          }
          p {
            margin: 5px 0 5px 0;
          }
        `}</style>
      </div>
    </Main>
  );
}
